import { PropsWithChildren, ReactNode } from "react";
import dashboardImage from "../resources/images/features/data-analysis.jpg";
import paymentMgtImage from "../resources/images/features/payment.jpg";
import attendanceImage from "../resources/images/features/attendance.jpg";
import membersImage from "../resources/images/features/members.jpg";
import notificationImage from "../resources/images/features/notification.jpeg";
import staffImage from "../resources/images/features/staff.jpg";
import mobileAppImage from "../resources/images/features/mobile-app.jpeg";
import { Avatar, Card, CardContent, CardHeader, Grid, styled } from "@mui/material";
import { PollIcon, EmojiPeopleIcon, EmailIcon, AttachMoneyIcon, EventAvailableIcon, GroupIcon, PhoneAndroidIcon, LoginIcon, FitnessCenterIcon, ShoppingCartIcon, ChecklistIcon, RestaurantMenuIcon } from "../shared/icons";

// const navBarHeight = 64;

const StyledCardContent = styled(CardContent)(({ theme }) => ({
    padding: '8px',
    '& .MuiTypography-root': {
        fontSize: '15px'
    },
    '& .MuiCardContent-root': {
        paddingBottom: '0'
    }
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
    backgroundColor: `${theme.palette.primary.main}`,
    height: '48px',
    width: '48px'
}));

const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
    '& .MuiTypography-root': {
        fontSize: '18px'
    }
}));

const StyledCard = styled(Card)(({ theme }) => ({
    padding: '8px',
    '& .MuiTypography-root': {
        margin: 'auto'
    }
}));

interface FeatureCardProps {
    readonly title: string
    readonly description?: string
    readonly image?: string
    icon: ReactNode
}

function FeatureCard({ title, icon, description }: PropsWithChildren<FeatureCardProps>) {
    return <Grid size={{ lg: 3, md: 6, sm: 12, xs: 12 }} sx={{ padding: '1rem', display: 'flex' }}>
        <StyledCard elevation={2} sx={{ border: '1px solid', borderColor: 'primary.main', '&:hover': { borderColor: 'primary.dark' } }}>
            <StyledCardHeader
                avatar={<StyledAvatar>{icon}</StyledAvatar>}
                title={title}
            />
            {/* <CardMedia
                component="img"
                height="224"
                image={image}
            /> */}
            <StyledCardContent>
                {description}
            </StyledCardContent>
        </StyledCard>
    </Grid>
}

export default function Features() {

    return (
        <div>
            <Grid container direction="row" sx={{mb: 4}}>
                <FeatureCard title="Powerful Analytical Dashboard"
                    icon={<PollIcon />}
                    image={dashboardImage}
                    description="Gain insights into your gym's performance with our powerful analytics dashboard."
                />
                <FeatureCard title="Member Management"
                    icon={<EmojiPeopleIcon />}
                    image={membersImage}
                    description="Easily manage memberships, member profiles, registrations, and account details in one place."
                />
                <FeatureCard title="Payment Tracking"
                    icon={<AttachMoneyIcon />}
                    image={paymentMgtImage}
                    description="Track membership payments, outstanding balances, and payment history effortlessly."
                >
                </FeatureCard>
                <FeatureCard title="Attendance Tracking"
                    icon={<EventAvailableIcon />}
                    image={attendanceImage}
                    description="Monitor member check-ins and attendance trends with accurate digital records."
                />
                <FeatureCard title="Staff Management"
                    icon={<GroupIcon />}
                    image={staffImage}
                    description="Manage your gym staff efficiently with our staff management tools."
                />
                <FeatureCard title="SMS Notifications"
                    icon={<EmailIcon />}
                    image={notificationImage}
                    description="Send instant reminders, announcements, promotions, and payment alerts directly to members."
                />
                <FeatureCard title="Member Login Portal"
                    icon={<LoginIcon />}
                    description="Provide members with secure access to their profiles, plans, and gym activities."
                />
                <FeatureCard title="Workout Plan Management"
                    icon={<FitnessCenterIcon />}
                    description="Create and assign personalized workout plans tailored to each member's fitness goals."
                />
                <FeatureCard title="Nutrition Plan Management"
                    icon={<RestaurantMenuIcon />}
                    description="Design structured meal plans and nutrition guidance to support member progress."
                />
                {/* <FeatureCard title="Technical Support"
                    icon={<ComputerIcon />}
                    image={techSupportImage}
                    description="Get reliable assistance whenever you need help with setup, troubleshooting, or training."
                /> */}
                <FeatureCard title="Mobile App"
                    icon={<PhoneAndroidIcon />}
                    image={mobileAppImage}
                    description="Access your gym management tools from any device on the go with our mobile app."
                />
                <FeatureCard title="Store Management"
                    icon={<ShoppingCartIcon />}
                    description="Manage supplements, merchandise, inventory, and sales from a centralized system."
                />
                <FeatureCard title="Task Management"
                    icon={<ChecklistIcon />}
                    description="Organize daily tasks, assign responsibilities, and track completion to improve productivity."
                />
            </Grid>
        </div>
    )
}